<div class="login-page" [style.background-image]="'url(' + bgLoginPath + ')'">
  <div class="login-page__container">
    <div class="login-card">
      <div class="login-card__header">
        <img [src]="logoPath" alt="Logo" class="login-card__logo">
        <h1 class="login-card__title">Xác thực 2 lớp</h1>
        <p class="login-card__subtitle" *ngIf="!useRecovery">
          Nhập mã 6 số hiển thị trong ứng dụng Authenticator của bạn
        </p>
        <p class="login-card__subtitle" *ngIf="useRecovery">
          Nhập một mã khôi phục bạn đã lưu khi thiết lập 2FA
        </p>
      </div>

      <!-- Nhập mã TOTP -->
      <form *ngIf="!useRecovery" [formGroup]="form" class="login-card__form" (ngSubmit)="submit()">
        <div class="login-field">
          <hbt-input-text
            class="login-input"
            [defaultInput]="true"
            labelText="Mã xác thực"
            placeholderText="Nhập mã 6 số"
            formControlName="code"
            [type]="isSubmitted && f['code'].errors ? 'error' : 'default'"
            [showError]="isSubmitted && f['code'].errors !== null"
            [errors]="f['code'].errors"
            [errorDefs]="[{ errorName: 'required', errorDescription: 'Bắt buộc nhập mã xác thực' }]">
          </hbt-input-text>
        </div>
        <button type="submit" class="login__btn" nz-button [disabled]="isLoading">Xác nhận</button>
        <div class="login-links">
          <a (click)="toggleRecovery()" class="login-links__item">Dùng mã khôi phục</a>
          <a (click)="backToLogin()" class="login-links__item">Quay lại đăng nhập</a>
        </div>
      </form>

      <!-- Nhập mã khôi phục -->
      <form *ngIf="useRecovery" [formGroup]="recoveryForm" class="login-card__form" (ngSubmit)="submitRecovery()">
        <div class="login-field">
          <hbt-input-text
            class="login-input"
            [defaultInput]="true"
            labelText="Mã khôi phục"
            placeholderText="Nhập mã khôi phục"
            formControlName="recoveryCode"
            [type]="isSubmitted && rf['recoveryCode'].errors ? 'error' : 'default'"
            [showError]="isSubmitted && rf['recoveryCode'].errors !== null"
            [errors]="rf['recoveryCode'].errors"
            [errorDefs]="[{ errorName: 'required', errorDescription: 'Bắt buộc nhập mã khôi phục' }]">
          </hbt-input-text>
        </div>
        <button type="submit" class="login__btn" nz-button [disabled]="isLoading">Xác nhận</button>
        <div class="login-links">
          <a (click)="toggleRecovery()" class="login-links__item">Dùng mã Authenticator</a>
          <a (click)="backToLogin()" class="login-links__item">Quay lại đăng nhập</a>
        </div>
      </form>

      <p class="login-card__footer">
        © 2026 • Trường Đại học Thương mại • Cổng đăng nhập SSO
      </p>
    </div>
  </div>
</div>
